<template>
  <!-- eslint-disable max-len vue/max-len -->
  <section class="privacy-page small-scroll-bar small-scroll-bar--black">
    <school-new-breadcrumbs
      :breadcrumbs="breadcrumbs"
      :borders="false"
    />

    <for-static-text>
      <h1>Политика конфиденциальности</h1>

      <p>
        Ваша конфиденциальность очень важна для нас. Мы хотим, чтобы Ваша работа в Интернет по возможности была максимально приятной и полезной, и чтобы Вы совершенно спокойно использовали широчайший спектр информации, инструментов и возможностей, которые предлагает Интернет. Персональные данные, собранные при регистрации (или в любое другое время) преимущественно используется для подготовки Продуктов или Услуг в соответствии с Вашими потребностями. Ваша информация не будет передана или продана третьим сторонам. Однако мы можем частично раскрывать личную информацию в особых случаях, описанных в данной Политике конфиденциальности.
      </p>

      <h4>Рамки Политики конфиденциальности</h4>
      <p>
        Настоящая Политика конфиденциальности (далее — «Политика») применяется к информации, полученной через данный сайт, иные сайты, виджеты и другие используемые интерактивные средства, на которых есть ссылка на данную Политику (далее — «Сайт») от пользователей Сайта (далее — «Пользователи»).
        <br>
        <br>
        Нижеследующие правила описывают, как Университет «Синергия» обращается с любой информацией, относящейся к прямо или косвенно определенному или определяемому физическому лицу (субъекту персональных данных) (далее — «Персональные данные»), для целей оказания услуг с использованием Сайта.
        <br>
        <br>
        Пользователи включают в себя всех физических лиц, которые подключаются к Сайту и используют Сайт.
        <br>
        <br>
        Пользователи прямо соглашаются на обработку своих Персональных данных, как это описано в настоящей Политике. Обработка означает любое действие (операцию) или совокупность действий (операций), совершаемых с использованием средств автоматизации или без использования таких средств с Персональными данными, включая сбор, запись, систематизацию, накопление, хранение, уточнение (обновление, изменение), извлечение, использование, передачу (распространение, предоставление, доступ), блокирование, удаление, уничтожение Персональных данных.
        <br>
        <br>
        Настоящая Политика конфиденциальности действует с 03 марта 2016 г.
      </p>

      <h4>Контролирующие и&nbsp;обрабатывающие&nbsp;лица</h4>
      <p>
        Пользователи соглашаются с тем, что:
        <ol>
          <li>Пользуясь Сайтом, и, принимая условия использования, опубликованные на Сайте, пользователь заявляет о своем однозначном согласии с обработкой его Персональных данных способами, описанными в настоящей Политике.</li>
          <li>Обработка Персональных данных Пользователей осуществляется Оператором персональных данных — Университет «Синергия» (ИНН: 7729152149, ОГРН: 1037700232558).</li>
        </ol>
      </p>

      <h4>С&nbsp;какой целью собираются эти&nbsp;данные</h4>
      <p>
        При регистрации на Сайте Пользователи подтверждают свое согласие с условиями настоящей Политики и свое согласие на обработку своих Персональных данных в соответствии с условиями настоящей Политики, кроме того, они соглашаются на обработку своих Персональных данных на серверах Университета «Синергия», расположенных на территории Российской Федерации.
        Обработка Персональных данных осуществляется не дольше, чем этого требуют цели обработки Персональных данных, изложенные в настоящей Политике (за исключением случаев, предусмотренных законодательством Российской Федерации). Университет «Синергия» может обрабатывать следующие Персональные данные:
        <ol>
          <li>адрес электронной почты и иную контактную информацию;</li>
          <li>сообщения, направляемые с использованием Сайта, и сообщения, направляемые в Университет «Синергия»;</li>
          <li>иную информацию о взаимодействии Пользователя с Сайтом Университета «Синергия», результаты сбора статистики посещений Сайта Университета «Синергия» и общедоступной информации о программах и устройствах, используемых для такового доступа;</li>
          <li>
            дополнительную информацию, которую Университет «Синергия» запрашивает у Пользователей для удостоверения их личности.
          </li>
        </ol>
      </p>

      <h4>Как эти данные используются</h4>
      <p>
        На сайте используются куки (Cookies) и данные о посетителях сервиса аналитики. При помощи этих данных собирается информация о действиях посетителей на сайте с целью улучшения его содержания, улучшения функциональных возможностей сайта и, как следствие, создания качественного контента и сервисов для посетителей. Вы можете в любой момент изменить настройки своего браузера так, чтобы браузер блокировал все файлы cookie или оповещал об отправке этих файлов. Учтите при этом, что некоторые функции и сервисы не смогут работать должным образом.
      </p>

      <h4>Как эти данные защищаются</h4>
      <p>
        Для защиты Вашей личной информации мы используем разнообразные административные, управленческие и технические меры безопасности. Наша Компания придерживается различных международных стандартов контроля, направленных на операции с личной информацией, которые включают определенные меры контроля по защите информации, собранной в Интернет. Наших сотрудников обучают понимать и выполнять эти меры контроля, они ознакомлены с нашим Уведомлением о конфиденциальности, нормами и инструкциями. Тем не менее, несмотря на то, что мы стремимся обезопасить Вашу личную информацию, Вы тоже должны принимать меры, чтобы защитить ее. Мы настоятельно рекомендуем Вам принимать все возможные меры предосторожности во время пребывания в Интернете. Организованные нами услуги и веб-сайты предусматривают меры по защите от утечки, несанкционированного использования и изменения информации, которую мы контролируем. Несмотря на то, что мы делаем все возможное, чтобы обеспечить целостность и безопасность своей сети и систем, мы не можем гарантировать, что наши меры безопасности предотвратят незаконный доступ к этой информации хакеров сторонних организаций.
        <br>
        <br>
        В случае изменения данной политики конфиденциальности вы сможете прочитать об этих изменениях на этой странице или, в особых случаях, получить уведомление на свой e-mail.
      </p>
    </for-static-text>
  </section>
</template>

<script>
import HeadMixin from '~/mixins/HeadMixin';
import SchoolNewBreadcrumbs from '../../components/v2/school-new/SchoolNewBreadcrumbs.vue';
import ForStaticText from '../../components/v2/common/ForStaticText.vue';

export default {
  name: 'PrivacyPage',
  components: {
    ForStaticText,
    SchoolNewBreadcrumbs,
  },
  mixins: [HeadMixin],
  layout: 'DefaultLayoutV2',
  scrollToTop: true,
  data: () => ({
    breadcrumbs: [
      { text: 'главная', to: '/' },
      { text: 'политика конфиденциальности ШУ Синергия', to: '/privacy' },
    ],

    // для head
    title: 'Политика обработки персональных данных | Школьный Университет «Синергия»',
    description: 'Политика обработки персональных данных | Школьный Университет «Синергия»',
    image: '/pages/privacy-share-image.jpg',
    canonical: true,
  }),
};
</script>

<style scoped lang="scss">
.privacy-page {
  padding-top: calc(var(--scale) * 110);
  padding-bottom: calc(var(--scale) * 128);
  padding-inline: calc(var(--scale) * 40);
  background-color: #ECEDF0;
  overflow: hidden;

  display: flex;
  flex-direction: column;
  gap: calc(var(--scale) * 20);

  font-family: 'Onest', sans-serif;

  @include media-down($size-tablet) {
    padding-inline: calc(var(--scale) * 16);
    padding-bottom: calc(var(--scale) * 80);
    gap: calc(var(--scale) * 10);
  }

  @include media-down($size-mobile) {
    padding-inline: calc(var(--scale) * 12);
  }

  ::v-deep(*) {
    font-family: "Onest", sans-serif;
  }
}

</style>
